<div class="w-[640px] flex flex-col gap-y-16">
  <div class="flex justify-between items-center">
    <h3>Wir freuen uns über Dein Feedback.</h3>
    <button class="btn btn-text" (click)="close()" aria-label="Schließen">
      <ng-icon name="heroXMark" size="20" strokeWidth="2" />
    </button>
  </div>
  @if (!!safeLink) {
  <iframe title="Umfrage" allow="fullscreen" height="480px" width="640px" [src]="safeLink" class="border-none">
    <strong class="font-bold text-red-400">
      Dein Browser unterstützt keine <code>iframe</code>s. Bitte aktualisiere Deinen Browser.
    </strong>
  </iframe>
  <small class="text-sm">
    Wenn Du später an der Umfrage teilnehmen möchtest, kannst Du das Fenster schließen und über Dein Profilbild erneut auf dieses
    Feedback-Formular kommen.
  </small>
  } @else {
  <p>Aktuell gibt es keine aktive Umfrage, an der Du teilnehmen kannst.</p>
  }
</div>
